<template>
  <div>
    <img
      v-if="thumbnail"
      :src="thumbnail"
      alt="Video thumbnail"
      style="
        width: 100%;
        height: 305px;
        max-height: 305px;
        min-height: 305px;
        border-radius: 15px;
        object-fit: cover;
      "
    />
    <img
      v-else
      :src="defaultThumbnail"
      alt="Fallback thumbnail"
      style="
        width: 100%;
        height: 305px;
        max-height: 305px;
        min-height: 305px;
        border-radius: 15px;
        object-fit: cover;
      "
    />
  </div>
</template>

<script>
export default {
  props: {
    videoUrl: { type: String, required: true },
    defaultThumbnail: {
      type: String,
      default: require("@/assets/images/postimage.png"),
    },
  },
  data() {
    return {
      thumbnail: null,
    };
  },
  mounted() {
    this.generateThumbnail();
  },
  methods: {
    generateThumbnail() {
      const video = document.createElement("video");
      video.src = this.videoUrl;
      video.crossOrigin = "anonymous";
      video.muted = true;
      video.playsInline = true;
      video.currentTime = 0.1;

      video.addEventListener("loadeddata", () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          this.thumbnail = canvas.toDataURL("image/jpeg");
        } catch (err) {
          console.warn("Thumbnail generation failed:", err);
          this.thumbnail = null;
        }
      });

      video.addEventListener("error", () => {
        console.warn("Video failed to load:", this.videoUrl);
        this.thumbnail = null;
      });
    },
  },
};
</script>
